'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdInput = function MdInput(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm18.4 26.6v-5h-16.8v-3.2h16.8v-5l6.6 6.6z m16.6-21.6c1.8 0 3.4 1.5 3.4 3.4v23.3c0 1.8-1.6 3.3-3.4 3.3h-30c-1.8 0-3.4-1.5-3.4-3.3v-6.7h3.4v6.7h30v-23.4h-30v6.7h-3.4v-6.6c0-1.8 1.6-3.4 3.4-3.4h30z' })
        )
    );
};

exports.default = MdInput;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/input.js
// module id = 3194
// module chunks = 0